import { Button, Clickable, H1, H2, H3, Image, P, Section, Wrapper } from '@ahmdigital/ui';

import {
  ABOUT_US_DESCRIPTION,
  FOOTNOTE,
  GOOD_BUNCH_DESCRIPTION,
  IMPORTANT_STUFF_DESCRIPTION,
  INSURANCE_THINGS_DESCRIPTION,
  MEET_THE_CREW_DESCRIPTION,
} from './constants';
import { URLS } from '../../models/url/constants';
import awardsImage from './img/we-money-and-finder.svg';
import Head from '../../../utils/head';
import LegacyBorderedWrapper from '../../components/legacy-bordered-wrapper';
import quadrupleFistbump from './img/quadruple-fistbump.svg';
import styles from './styles.module.sass';
import wollongong from './img/wollongong.svg';

const heading = 'About us';

const AboutPage = () => (
  <LegacyBorderedWrapper>
    <Head>
      <title>{heading}</title>
      <meta
        name="description"
        content="Finder's Health Fund of the Year 2026. 1M+ members and 50+ years in. We do health insurance for people things - whatever that looks like for you."
      />
    </Head>
    <Section variant="large" theme="black" className={styles.banner}>
      <Wrapper>
        <H1>{heading}</H1>
        {ABOUT_US_DESCRIPTION}
      </Wrapper>
    </Section>
    <Section variant="large">
      <Wrapper>
        <H2 looksLike="h3">We do insurance for people things</H2>
        <div>{INSURANCE_THINGS_DESCRIPTION}</div>
      </Wrapper>
    </Section>
    <Section variant="large" theme="grey10">
      <Wrapper className={styles.awardsSection}>
        <Image className={styles.image} alt="Finder and WeMoney Awards" src={awardsImage.src} />
        <div className={styles.awardsCopy}>
          <H2 looksLike="h3">Best health fund or best value? Both, actually</H2>
          <P>
            Finder’s 2026 Health Fund of the Year and WeMoney’s Best for Value 2026 — award-winning health insurance,
            twice.
          </P>
          <Button variant={['border', 'transparentBlack']} to={URLS.SALES.AWARDS}>
            Explore award-winning health insurance
          </Button>
        </div>
      </Wrapper>
    </Section>
    <Section className={styles.wrapperSection}>
      <Wrapper>
        <Section variant="large">
          <H2 looksLike="h3">Meet the crew behind the cover</H2>
          <div className={styles.imageSection}>
            <div>{MEET_THE_CREW_DESCRIPTION}</div>
            <Image alt="Wollongong" className={styles.image} height={191} src={wollongong} useNextImage width={332} />
          </div>
        </Section>
        <Section variant="large">
          <H3 looksLike="h4">We take the important stuff seriously</H3>
          <P>{IMPORTANT_STUFF_DESCRIPTION}</P>
        </Section>
      </Wrapper>
    </Section>
    <Section variant="large" theme="grey10">
      <Wrapper className={styles.imageSection}>
        <div>
          <H2 looksLike="h3">We’re a good bunch</H2>
          <div>{GOOD_BUNCH_DESCRIPTION}</div>
        </div>
        <Image
          alt="Quadruple Fistbump"
          className={styles.image}
          height={191}
          src={quadrupleFistbump}
          useNextImage
          width={332}
        />
      </Wrapper>
    </Section>
    <Section variant="large" className={styles.footnote}>
      <Wrapper>
        <H2 looksLike="h3">So now you know us a little better</H2>
        <P>{FOOTNOTE}</P>
        <Clickable to={URLS.SALES.HEALTH_INSURANCE}>Find out more</Clickable>
      </Wrapper>
    </Section>
  </LegacyBorderedWrapper>
);

export default AboutPage;
